import essoxLogoFooter from '@/images/clients/essox-logo.png'
import type { IPartnerSettings } from '.'

const origAppUrl = {
  development: 'https://localhost/Car.Web.Client.Essox',
  test: 'https://essoxpojisteni.cz/test',
  prep: '',
  production: 'https://essoxpojisteni.cz/prod',
}

const hosts = [
  'www.essoxpojisteni.cz',
  'essoxpojisteni.cz'
  //, 'localhost:44470'
]

export const Essox: IPartnerSettings = {
  partner: 'Essox',
  deployment: 'Essox',
  origAppUrl: origAppUrl,
  hosts: hosts,
  logo: essoxLogoFooter
}

export const AutoEsa: IPartnerSettings = {
  partner: 'AutoEsa',
  deployment: 'Essox',
  origAppUrl: origAppUrl,
  hosts: hosts,
  logo: essoxLogoFooter
}

export const DirectAuto: IPartnerSettings = {
  partner: 'DirectAuto',
  deployment: 'Essox',
  origAppUrl: origAppUrl,
  hosts: hosts,
  logo: essoxLogoFooter
}
